import { useEffect } from "react";
import useServicesStore from "../../../store/servicesStore";
import { currencyFormat } from "../../../utils/numbers.util";

export const TableServices = () => {
    const { total, services, removeService, calculateTotal } = useServicesStore();
    
    useEffect(() => {
      calculateTotal();
    }, [services, calculateTotal]);

    return (
      <>
        {Boolean(services?.length) && (
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Servicio</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Precio</th>
                <th scope="col" style={{ textAlign: "center" }}>
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {services.map(({ serviceId, name, quantity, price }, i) => (
                <tr key={serviceId}>
                  <th scope="row">{i + 1}</th>
                  <td>{name}</td>
                  <td>{quantity}</td>
                  <td>{price}</td>
                  <td style={{ textAlign: "right" }}>
                    $ {currencyFormat(price * quantity)}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeService(serviceId)}
                    >
                      <span className="fas fa-trash"></span>
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="5" style={{ textAlign: "right", color:'red', fontWeight: 600 }}>
                  $ {currencyFormat(total)}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </>
    );
}